<script  setup>

import moment from 'moment';
import {
    ElCol,
    ElRow,
    ElCard,
    ElText,
    ElButton,
    ElSlider,
    ElCheckboxGroup,
    ElCheckboxButton,
    ElCheckbox,
    ElLoading, FormInstance, ElDatePicker, ElMessage
} from "element-plus";
import axios from "axios";
import {computed, reactive, ref, watch} from "vue";
import { moneyTotal, formatMoney, roundMoney } from '../../../../utils/money';

const ruleFormRef = ref()

const props = defineProps({
    hotel:Object,
    form:Object,
    staytypes:Object,
    roomtypes:Object,
    mealplans:Object

});
const emit = defineEmits(['removehotel']);
const hotel = computed(() => props.hotel);
const form=props.form;
const datepickervalue=ref(['',''])
const staytypes=props.staytypes;
const roomtypes=props.roomtypes;

const mealplans=props.mealplans;


const showdetails=ref(false);
const editprice=ref(false);


const removehotel=(flight)=>{
    emit('removehotel',flight)
}

const rules = reactive({
    name: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    rating: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    city: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    checkIn: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ]

});

const editform=reactive(
    {
        "name":hotel.value.data.name,
        "rating":hotel.value.data.rating,
        "type":hotel.value.data.type,
        "address":hotel.value.data.address,
        "city":hotel.value.data.city,
        "rooms":hotel.value.data.rooms,
        "checkIn":hotel.value.data.checkIn,
        "checkOut":hotel.value.data.checkOut,
        "comments":hotel.value.data.comments,
        "pricing":{
            "total":hotel.value.pricing.total,
            "adult":hotel.value.pricing.adult ,
            "child":hotel.value.pricing.child ,
            "infant":hotel.value.pricing.infant ,
        }
    }
)



const KNOWN_MEAL_PLANS = [
    'ROOMONLY',
    'BREAKFAST',
    'LUNCH',
    'DINNER',
    'HALFBOARD',
    'FULLBOARD',
    'ALLINCLUSIVE',
];

const normalizeMealPlanToken = (raw) => {
    const value = String(raw || '').trim();
    if (!value) {
        return [];
    }

    const compact = value.toUpperCase().replace(/[\s_-]+/g, '');
    if (KNOWN_MEAL_PLANS.includes(compact)) {
        return [compact];
    }

    const lower = value.toLowerCase();
    if (lower.includes('all inclusive') || lower === 'ai') {
        return ['ALLINCLUSIVE'];
    }
    if (lower.includes('full board') || lower === 'fb') {
        return ['FULLBOARD'];
    }
    if (lower.includes('half board') || lower === 'hb') {
        return ['HALFBOARD'];
    }
    if (lower.includes('room only') || lower === 'ro') {
        return ['ROOMONLY'];
    }

    const codes = [];
    if (lower.includes('breakfast') || lower.includes('break fast') || lower === 'bb') {
        codes.push('BREAKFAST');
    }
    if (lower.includes('lunch')) {
        codes.push('LUNCH');
    }
    if (lower.includes('dinner')) {
        codes.push('DINNER');
    }

    return codes;
};

/** Expand "Breakfast, Dinner" (and arrays containing that) into CRM meal codes. */
const normalizeMealPlans = (mb) => {
    const list = Array.isArray(mb) ? mb : (mb ? [mb] : []);
    const codes = [];

    list.forEach((item) => {
        if (item == null || item === '') {
            return;
        }
        if (Array.isArray(item)) {
            codes.push(...normalizeMealPlans(item));
            return;
        }

        const parts = String(item).split(/\s*[,|/]\s*/).map((part) => part.trim()).filter(Boolean);
        if (parts.length > 1) {
            parts.forEach((part) => {
                codes.push(...normalizeMealPlanToken(part));
            });
            return;
        }

        codes.push(...normalizeMealPlanToken(item));
    });

    return [...new Set(codes)];
};

const formatMealPlan = (mb) => {
    const plans = normalizeMealPlans(mb);
    return plans.length ? plans.join(', ') : '';
};

const normalizeRoomMeals = (rooms) => {
    return (rooms || []).map((room) => ({
        ...room,
        mb: normalizeMealPlans(room.mb),
    }));
};

const reloadloada = () => {
    editform.name=hotel.value.data.name;
    editform.rating=hotel.value.data.rating;
    editform.type=hotel.value.data.type;
    editform.address=hotel.value.data.address;
    editform.city=hotel.value.data.city;
    editform.rooms=normalizeRoomMeals(JSON.parse(JSON.stringify(hotel.value.data.rooms)));
    editform.checkIn=hotel.value.data.checkIn;
    editform.checkOut=hotel.value.data.checkOut;
    editform.comments=hotel.value.data.comments;
    editform.pricing.total=hotel.value.pricing.total;
    editform.pricing.adult=hotel.value.pricing.adult;
    editform.pricing.child=hotel.value.pricing.child;
    editform.pricing.infant=hotel.value.pricing.infant;
    datepickervalue.value=[hotel.value.data.checkIn,hotel.value.data.checkOut];

};

const updateupricecount = () => {
    editform.pricing.total = moneyTotal(
        form.adults,
        editform.pricing.adult,
        form.childs,
        editform.pricing.child,
        form.infants,
        editform.pricing.infant
    );
};
const savePrice = () => {
    hotel.value.data.name=editform.name;
    hotel.value.data.rating=editform.rating;
    hotel.value.data.type=editform.type;
    hotel.value.data.address=editform.address;
    hotel.value.data.city=editform.city;
    hotel.value.data.rooms=JSON.parse(JSON.stringify(editform.rooms));
    hotel.value.data.checkIn=editform.checkIn;
    hotel.value.data.checkOut=editform.checkOut;
    hotel.value.data.comments=editform.comments;
    hotel.value.pricing.total=roundMoney(editform.pricing.total);
    hotel.value.pricing.adult=roundMoney(editform.pricing.adult);
    hotel.value.pricing.child=roundMoney(editform.pricing.child);
    hotel.value.pricing.infant=roundMoney(editform.pricing.infant);
    editprice.value=false;
};
const edithotel = () => {
    reloadloada();
    editprice.value=true;
};


const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {


            let  radts=0;
            let  rchds=0;

            for (let i = 0; i < editform.rooms.length; i++) {
                const room=editform.rooms[i];
                radts += parseInt(room.adt)*parseInt(room.quantity);
                rchds += parseInt(room.chd)*parseInt(room.quantity);
            }



            if(radts==form.adults && rchds==form.childs){
                savePrice()
            }
            else{
                ElMessage({
                    message: 'Adults and Child Count is Incorrect.',
                    type: 'error',
                })
            }


        }
    })
}


watch(
    () => editform.pricing,
    () => {
        updateupricecount();
    },
    { deep:true}
)


watch(
    () => datepickervalue,
    (newValue, oldValue) => {

        editform.checkIn=datepickervalue.value[0];
        editform.checkOut=datepickervalue.value[1];
    }
    ,
    { deep: true }
)


const removeroom=(room)=>{
    const index = editform.rooms.indexOf(room)
    if (index !== -1) {
        editform.rooms.splice(index, 1)
    }
}

const addroom=()=>{
    editform.rooms.push(
        {
            "type": "", "amenities": [], "adt": 0, "chd": 0, "mb": [], "price": 0
        }
    )
}
const disabledDate = (time) => {
    return time.getTime() < moment(String(form.departure_date)).toDate() || time.getTime() > moment(String(form.departure_date)).add(form.nights, 'day').toDate()
}

</script>

<template>
    <el-card class="mb-3"  shadow="never" :body-style="{padding:0}">
        <div class="flex">

            <div class="p-2" style="width: 100%;">
                <div>
                    <el-text tag="b" size="large">{{hotel.data.name}}</el-text>
                    <el-text tag="p" size="small" >{{hotel.data.address}} , {{hotel.data.city}}</el-text>
                    <el-text tag="p" size="small" >{{hotel.data.type}}</el-text>
                    <el-text tag="p" size="small" >CheckIn - {{hotel.data.checkIn}} | CheckOut - {{hotel.data.checkOut}}</el-text>


                    <el-rate
                        v-model="hotel.data.rating"
                        disabled
                        show-score
                        text-color="#ff9900"
                        size="small"
                        score-template="{value} Stars"
                    />
                </div>
                <div>
                    <el-text tag="b" size="large">Rooms</el-text>
                    <div v-for="room in hotel.data.rooms">
                        <el-text tag="b">{{room.quantity}} X {{room.type}}  </el-text>
                        <el-text > for {{room.adt*room.quantity}} adults   </el-text>
                        <el-text v-if="room.chd>0">  {{room.chd*room.quantity}} child   </el-text>
                        <el-text tag="b" size="small"> - {{formatMealPlan(room.mb)}}  </el-text>

                    </div>
                </div>
                <div v-if="hotel.data.comments">
                    <el-text tag="b" size="large">Comments</el-text>
                    <el-text tag="p" >{{hotel.data.comments}}</el-text>

                </div>


            </div>
            <div class="p-2">
                <div>
                    <el-dropdown trigger="hover">
                        <el-text tag="b" size="large">₹{{ formatMoney(hotel.pricing.total) }} </el-text>

                        <template #dropdown>
                            <p >
                                Adult - ₹  {{formatMoney(hotel.pricing.adult)}}
                            </p>
                            <p v-if="form.childs>0">
                                Child - ₹  {{formatMoney(hotel.pricing.child)}}
                            </p>
                            <p v-if="form.infants>0">
                                Infant - ₹  {{formatMoney(hotel.pricing.infant)}}
                            </p>

                        </template>
                    </el-dropdown>
                </div>
                <div>
                    <el-button type="info" size="small" @click="edithotel()" >Edit</el-button>
                    <el-button type="danger" size="small" @click="removehotel(hotel)" >Remove</el-button>

                </div>




            </div>
        </div>


    </el-card>

    <el-dialog
        v-model="editprice"
        title="Edit Stay"
        width="80%"

    >
        <el-form
            ref="ruleFormRef"
            :model="editform"
            status-icon
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"
            size="small"
            :rules="rules"

        >
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-form-item label="Type"  prop="type"
                                  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-select
                            v-model="editform.type"
                            placeholder="Room Type"
                            style="width: 100%"
                            allow-create
                            filterable
                        >
                            <el-option
                                v-for="item in staytypes"
                                :key="item"
                                :label="item"
                                :value="item"
                            />

                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" >
                    <el-form-item label="Hotel name" prop="name">
                        <el-input v-model="editform.name"  placeholder="Hotel Name" />
                    </el-form-item>

                </el-col>
                <el-col :span="8" >
                    <el-form-item label="Address" prop="address">
                        <el-input v-model="editform.address"  placeholder="Address" />
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="City" prop="city" >
                        <el-input v-model="editform.city"  placeholder="City" />
                    </el-form-item>

                </el-col>

            </el-row>
            <el-row :gutter="20">
                <el-col :span="4" >
                    <el-form-item label="Ratings" prop="rating">
                        <el-select
                            v-model="editform.rating"
                            placeholder="Select Rating"
                            style="width: 100%"
                        >
                            <el-option
                                :key="5"
                                label="5 Star"
                                :value="5"
                            />
                            <el-option
                                :key="4"
                                label="4 Star"
                                :value="4"
                            />
                            <el-option
                                :key="3"
                                label="3 Star"
                                :value="3"
                            />
                            <el-option
                                :key="2"
                                label="2 Star"
                                :value="2"
                            />
                            <el-option
                                :key="1"
                                label="1 Star"
                                :value="1"
                            />
                        </el-select>
                    </el-form-item>

                </el-col>
                <el-col :span="6" >
                    <el-form-item label="Dates" prop="checkIn">
                        <el-date-picker
                            v-model="datepickervalue"
                            type="daterange"
                            range-separator="To"
                            start-placeholder="Check-In"
                            end-placeholder="Check-Out"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"
                            :clearable="false"
                            :disabled-date="disabledDate"

                        />

                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20">
                <el-col :span="2" >
                    <el-form-item label="Adults" >
                        <el-input v-model="form.adults"  placeholder="Adults" disabled/>
                    </el-form-item>

                </el-col>
                <el-col :span="3" >
                    <el-form-item label="Price (Per Adult)" prop="pricing.adult" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.adult"  placeholder="Price (Per Adult)" />
                    </el-form-item>

                </el-col>

                <el-col :span="2" v-if="form.childs>0">
                    <el-form-item label="Childs" >
                        <el-input v-model="form.childs"  placeholder="Childs" disabled/>
                    </el-form-item>

                </el-col>
                <el-col :span="3" v-if="form.childs>0">
                    <el-form-item label="Price (Per Child)" prop="pricing.child" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.child"  placeholder="Price (Per Child)" />
                    </el-form-item>

                </el-col>
                <el-col :span="2" v-if="form.infants>0">
                    <el-form-item label="Infants" >
                        <el-input v-model="form.infants"  placeholder="Childs" disabled/>
                    </el-form-item>

                </el-col>
                <el-col :span="3" v-if="form.infants>0">
                    <el-form-item label="Price (Per Infant)" prop="pricing.infant" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.infant"  placeholder="Price (Per Infant)" />
                    </el-form-item>

                </el-col>

                <el-col :span="3" >
                    <el-form-item label="Total Price" >
                        <el-input v-model="editform.pricing.total"  placeholder="Total Price" disabled/>
                    </el-form-item>

                </el-col>

            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-text size="large" tag="b">Rooms</el-text>&nbsp;&nbsp;
                    <el-button type="primary" size="small" @click="addroom()" >Add Room</el-button>
                </el-col>
                <el-col :span="24" v-for="(room,index) in editform.rooms">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="Room Type"  :prop="'rooms.' + index + '.type'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-select
                                    v-model="room.type"
                                    placeholder="Room Type"
                                    style="width: 100%"
                                    allow-create
                                    filterable
                                >
                                    <el-option
                                        v-for="item in roomtypes"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />

                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="Quantity" :prop="'rooms.' + index + '.quantity'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-input v-model="room.quantity" type="number"  placeholder="Quantity" />
                            </el-form-item>

                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="Meal Plan" :prop="'rooms.' + index + '.mb'"
                                          :rules="{
                                                        type: 'array',
                                                        required: true,
                                                        min: 1,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-select
                                    v-model="room.mb"
                                    placeholder="Meal Plan"
                                    multiple
                                    filterable
                                    collapse-tags
                                    collapse-tags-tooltip
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="item in mealplans"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />

                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="Adults" :prop="'rooms.' + index + '.adt'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-input v-model="room.adt"  placeholder="Adults" />
                            </el-form-item>

                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="Child" :prop="'rooms.' + index + '.chd'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-input v-model="room.chd"  placeholder="Child" />
                            </el-form-item>

                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="." >
                                <el-button type="danger" size="small" @click="removeroom(room)" >Remove</el-button>
                            </el-form-item>


                        </el-col>

                    </el-row>
                </el-col>

            </el-row>

            <el-row :gutter="20">
                <el-col :span="24" >
                    <el-form-item label="Comments" >
                        <el-input type="textarea" v-model="editform.comments"  placeholder="Comments" />
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="editprice = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                    Save
                </el-button>
            </div>
        </template>

    </el-dialog>
</template>

<style scoped>

</style>
